import { makeLineOption } from '../utils';

export function makeLineCharts({ data, title, prop, color }) {
  return makeLineOption({
    color: [color],
    yAxis: {
      name: 'V'
    },
    series: [{ encode: { x: 'timestamp', y: prop, seriesName: prop } }],
    dataset: {
      dimensions: [
        { name: 'time', type: 'time' },
        { name: prop, displayName: title }
      ],
      source: data
    }
  });
}
